import { Component, Input, OnInit } from "@angular/core";
import { ElementComponent } from "./element.component";
import { Listing } from "@app/data/listing";

@Component({
  selector: "n-listing",
  template: ` <div class="n-listing"></div> `,
})
export class ListingComponent extends ElementComponent implements OnInit {
  @Input("listing")
  listing: Listing;

  ngOnInit() {
    super.ngOnInit();
  }
}
